module.exports = __webpack_public_path__ + "img/img-banner-consultoria-Digital.b50a0efc.png";